import React from 'react'
import Layout from '../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const UTMTC = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FmaterialTesting%2F11.png?alt=media&token=c0e3422c-9658-49af-bf28-91c05e038a25',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FmaterialTesting%2F11.png?alt=media&token=c0e3422c-9658-49af-bf28-91c05e038a25'
    ];

    return (
        <Layout>
            {/* Breadcrumb */}
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/instruments-materialtesting">Material Testing</a></li>
                </ul>
            </div>

            {/* Title */}
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Universal Testing Machine with Temperature Chamber</h1>
                </div>
            </div>

            {/* Main Section */}
            <section
                id="portfolio-details"
                className="portfolio-details"
                style={{ backgroundColor: 'white', marginBottom: '12rem' }}
            >
                <div className="container">
                    <div className="row gy-4">

                        {/* Image Slider */}
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img
                                                    src={src}
                                                    alt="UTM TC"
                                                    className="responsive"
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>

                        {/* Description */}
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Universal Testing Machine (UTM – TC)</h3>

                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    Our Universal Testing Machine (UTM) is a mechanical testing device
                                    used to evaluate the strength and mechanical properties (tensile,
                                    compression, bend, shear) of materials under influence of Temperature
                                    ranges from room temperature to 600° C.
                                    <br />
                                    They are useful in R&amp;D, product design and quality control.
                                    Our UTM ranges from 3N to 500 KN. User can select machine’s
                                    capacity, test space, stroke, strength, and speed according to test
                                    requirement.
                                    <br />
                                    A temperature chamber enables realistic simulations of materials in
                                    Textile, Aerospace, Automotive and Other Industries.More

                                    <br /><br />

                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Universal Testing Machine"
                                        style={{
                                            color: '#0d6efd',
                                            fontWeight: '600',
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>

                            <div className="portfolio-description"></div>
                        </div>

                    </div>
                </div>
            </section>

            <br />
        </Layout>
    )
}

export default UTMTC;